import bmdReport from "./bmdReport.vue";
export default bmdReport;
